import { IStackProps, VStack } from 'native-base';
import React from 'react';
import { Linking } from 'react-native';

import CPAlert from 'app/components/CPAlert';
import HTML from 'app/components/HTML';
import { NoticePlacements } from 'app/generated/hygraph';
import useNotices from 'app/hooks/useNotices';
import Analytics, { Events } from 'app/services/Analytics';
import { getDescription, getTheme, getTitle } from 'app/services/NoticeHelper';
import { tID } from 'app/services/TestHelper';

export type NoticePlacementProps = IStackProps & {
  placement?: NoticePlacements;
  productContentKey?: string;
  attractionContentKey?: string;
  messageProps?: Record<string, string | string[]>;
};

export default function Notices({
  placement,
  productContentKey,
  attractionContentKey,
  messageProps,
  ...props
}: NoticePlacementProps) {
  const { data: notices } = useNotices({
    placement,
    productContentKey,
    attractionContentKey,
  });

  if ((notices?.length ?? 0) === 0) return null;

  return (
    <VStack my="4" space="3" testID={tID('Notices')} {...props}>
      {notices?.map((notice) => (
        <CPAlert
          key={notice.id}
          collapsible
          initialOpen={notice.defaultOpen}
          theme={getTheme(notice)}
          title={getTitle(notice)}
          onExpand={() => {
            Analytics.trackEvent(Events.NotificationExpand, {
              noticeId: notice.id,
              noticeKey: notice.key,
              placementId: placement ?? 'UNKNOWN',
            });
          }}
        >
          <HTML
            html={getDescription(notice, messageProps)}
            renderersProps={{
              a: {
                async onPress(_event, href, attributes) {
                  Analytics.trackEventFromLinkPress(attributes, {
                    productKey: productContentKey ?? 'UNNKOWN',
                    attractionKey: attractionContentKey ?? 'UNKNOWN',
                    noticeId: notice.id,
                    noticeKey: notice.key,
                    placementId: placement ?? 'UNKNOWN',
                  });
                  await Linking.openURL(href);
                },
              },
            }}
          />
        </CPAlert>
      ))}
    </VStack>
  );
}
